import { render } from "./page-mortgages.vue?vue&type=template&id=198194b6"
import script from "./page-mortgages.js?vue&type=script&lang=js"
export * from "./page-mortgages.js?vue&type=script&lang=js"

import "./page-mortgages.vue?vue&type=style&index=0&id=198194b6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__